import { StyledSVG } from '../../Atoms/SVG/styles'
import { StyledText } from '../../Atoms/Text/styles'
import { StyledChatInput } from '../../Molecules/ChatInput/styles'
import { styled } from '../../Styles/stitches.config'

export const ChatIcon = styled('div', {
    size: 28,

    [`& ${StyledSVG}`]: {
        h: '100%',
    },
})

export const StyledMessageContent = styled('div', {
    alignItems: 'end',
    color: '$white',
    display: 'flex',
    gap: '$1',
    justifyContent: 'start',

    '@desktop': {
        maxW: 500,
        w: '80%',
    },

    '@mobile': {
        maxW: 250,
    },

    [`& ${StyledText}`]: {
        br: '$3',
        px: 'calc($2 + $1)',
        py: '$1',
        whiteSpace: 'pre-line',
        wordBreak: 'break-word',
    },

    variants: {
        user: {
            admin: {
                [`& ${StyledText}`]: {
                    bgc: '$secondary500',
                },
            },
            receiver: {
                [`& ${StyledText}`]: {
                    bgc: '$primary300',
                },
            },
            sender: {
                flexDirection: 'column',
                justifySelf: 'end',

                [`& ${StyledText}`]: {
                    bgc: '$primary500',
                },
            },
        },
    },
})

export const StyledThread = styled('div', {
    borderBottom: '1px solid $neutral200',
    display: 'flex',
    flexDirection: 'column-reverse',
    overflowY: 'scroll',
    p: '$3 0 $3 $2',

    '&::-webkit-scrollbar': {
        w: 14,
    },

    '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 10px 10px $colors$neutral200',
        border: '4px solid transparent',
        br: '$2',
    },

    '&::-webkit-scrollbar-thumb': {
        boxShadow: 'inset 0 0 10px 10px $colors$neutral500',
        border: '4px solid transparent',
        br: '$2',
    },

    '.infinite-scroll-component': {
        display: 'flex',
        flexDirection: 'column-reverse',
        gap: '$2',
        maxH: '100%',
    },
})

export const StyledChat = styled('div', {
    alignContent: 'end',
    display: 'grid',
    h: '100%',
    overflow: 'hidden',

    [`& ${StyledChatInput}`]: {
        p: '$2 $3 $3',
    },
})
